const PARENT_TIMEOUT_MS = 900
const CAVEON_ORIGIN_PATTERN = /^https:\/\/[a-z0-9.-]+\.caveon\.(com|dev)(:\d+)?$/i

let cloudHosted = false
let locationInterval = null

export function isCloudHosted() {
  return cloudHosted
}

export function isAllowedHostOrigin(origin) {
  return CAVEON_ORIGIN_PATTERN.test(origin)
}

export function normalizeHostMessage(event) {
  if (!event || !event.data) return null

  if (event.data.name === 'post-message' && event.data.args && event.data.args[0]) {
    return event.data.args[0]
  }

  return event.data
}

export async function detectCloudHost() {
  if (!hasParentHost() && forcedHostMode() !== 'cloud') {
    cloudHosted = false
    return null
  }

  const accessToken = await requestAccessToken(PARENT_TIMEOUT_MS)
  cloudHosted = Boolean(accessToken)
  return accessToken
}

export function emitLoaded() {
  if (!cloudHosted) return
  emitToParent('loaded')
}

export function postCaveonIdMessage(payload) {
  if (!cloudHosted) return
  emitToParent('post-message', payload)
}

export async function requestAccessToken(timeoutMs = 5000) {
  if (!hasParentHost() && forcedHostMode() !== 'cloud') return null

  return requestFromParent('get-access-token', timeoutMs)
}

export function startLocationSync() {
  if (!cloudHosted || locationInterval) return

  let lastLocation = window.location.href
  locationInterval = window.setInterval(() => {
    if (window.location.href === lastLocation) return

    lastLocation = window.location.href
    emitToParent('update-cloud-state', { location: lastLocation })
  }, 1000)
}

export function stopLocationSync() {
  if (!locationInterval) return

  window.clearInterval(locationInterval)
  locationInterval = null
}

function requestFromParent(name, timeoutMs) {
  return new Promise(resolve => {
    const promiseID = createPromiseID()
    const timeout = window.setTimeout(() => {
      window.removeEventListener('message', onMessage)
      resolve(null)
    }, timeoutMs)

    function onMessage(event) {
      if (!isAllowedHostOrigin(event.origin)) return

      const message = normalizeHostMessage(event)
      if (!message) return

      if (message.promiseID === promiseID) {
        finish(message.args && message.args[0])
        return
      }

      if (name === 'get-access-token' && ['access-token', 'caveonid_access_token'].includes(message.type)) {
        finish(message.token || message.accessToken)
      }
    }

    function finish(value) {
      window.clearTimeout(timeout)
      window.removeEventListener('message', onMessage)
      resolve(value || null)
    }

    window.addEventListener('message', onMessage)
    emitToParent(name, promiseID)
  })
}

function emitToParent(name, payload) {
  if (!hasParentHost()) return

  const args = typeof payload === 'undefined' ? [] : [payload]
  window.parent.postMessage({ name, args }, parentOrigin())
}

function parentOrigin() {
  try {
    return new URL(document.referrer).origin
  } catch (error) {
    return '*'
  }
}

function hasParentHost() {
  return window.parent && window.parent !== window
}

function forcedHostMode() {
  const configuredMode = window.SCORPION_HOST_MODE || queryParam('scorpion_host_mode') || queryParam('host_mode')
  return configuredMode ? String(configuredMode).toLowerCase() : ''
}

function queryParam(name) {
  const match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'))
  return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : ''
}

function createPromiseID() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID()
  }

  return `${Date.now()}-${String(Math.random()).slice(2)}`
}
